import type { ValueOf } from 'type-fest';
import type { FeatureTourStep } from '../components/FeatureTour';

/**
 * Available placement options for tour popovers.
 *
 * Position grid:
 * ┌───────────────────────────────────────────-----──────--─┐
 * │  Position  │   Left      │  Center      │  Right        │
 * ├─────────────────────────────────────────────────────---─┤
 * │  Top       │  top-left   │  top-center  │  top-right    │
 * │  Bottom    │  bottom-left│  bottom-center│ bottom-right │
 * │  Side      │  left       │      —       │  right        │
 * └─────────────────────────────────────────────────-------─┘
 *
 * - Top/Bottom placements: popover appears above/below the target
 * - Left/Right variants: popover edge aligns flush with target edge
 * - Center variants: popover is horizontally centered on target
 * - Side placements: popover appears beside the target, vertically centered
 */
export const TOUR_PLACEMENT = {
  TOP_LEFT: 'top-left',
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type TourPlacement = ValueOf<typeof TOUR_PLACEMENT>;

export const FT_PROPERTIES_PAGE_CONFIG: {
  tourId: string;
  steps: Array<FeatureTourStep>;
} = {
  tourId: 'feature-tour:properties-page-2025-12',
  steps: [
    {
      id: 'PropertyRow',
      target: '#PropertyRow-0',
      title: '',
      body: 'Your Apartment units properties are now visually grouped for easier management.',
      placement: TOUR_PLACEMENT.BOTTOM_RIGHT,
      popoverOffset: { top: 0, left: 0 },
    },
    {
      id: 'PropertyRow-Cell',
      target: '#PropertyRow-0-Cell-0',
      title: '',
      body: 'Click on any property to see detailed information and manage your listing.',
      placement: TOUR_PLACEMENT.BOTTOM_RIGHT,
    },
    {
      id: 'PropertyRow-Lease-Cell',
      target: '#PropertyRow-Lease-Cell',
      title: '',
      body: 'View leases for this property.',
      placement: TOUR_PLACEMENT.LEFT,
    },
  ],
};

export const FT_FLEXIBLE_PROPERTIES_PAGE_CONFIG: {
  tourId: string;
  steps: Array<FeatureTourStep>;
} = {
  tourId: 'feature-tour:flexible-properties-page-2026-07',
  steps: [
    {
      id: 'ControlledSearchBox',
      target: '#ft-toolbar-search',
      title: '',
      body: 'Search for properties by name, address, or unit number.',
      placement: TOUR_PLACEMENT.BOTTOM_RIGHT,
      popoverOffset: { top: 0, left: 0 },
    },
    {
      id: 'ViewMode',
      target: '#ft-toolbar-view-mode',
      title: '',
      body: 'Select the way you want to view your properties.',
      placement: TOUR_PLACEMENT.BOTTOM_RIGHT,
    },
    {
      id: 'FlexiblePropertyCardHeader',
      target: '#ft-flexible-property-card-header',
      title: '',
      body: 'Click on the property card to see detailed information and manage your listing.',
      placement: TOUR_PLACEMENT.LEFT,
    },
  ],
};
